module.exports = __webpack_public_path__ + "img/video-poster.2904d2ab.png";